import React, {useState} from "react";
import InitializePage from '../../../lib/server/page';
import Header from "../../../components/Layouts/Header";
import HomeFooter from '../../../components/Layouts/HomeFooter.jsx';
import SubscribeNewsLetter from '../../../components/common/subscribenewsletter.jsx';
import { useRouter } from 'next/router';
import {validationEmail } from '../../../lib/api/auth';

import { notifyMe } from "../../../helper";


const ValidationResend = ({menu, webTexts}) => {
    const router = useRouter();
    let email = useState(router?.query?.email);
    const [emailSent, setEmailSent] = useState(false);

    const sendValidationEmail = async () => {
        if(email[0]){
            let response = await validationEmail(email[0]);
            if (response.success === true) {
                setEmailSent(true);
                notifyMe({ key: 'signIn', method: 'success', message: 'Email sent', description: 'Validation email has been sent!' });
            }
        }
    }
    return (
        <>
            <Header page={'common'} menuSections={menu}/>        
                <div className="container innerpage main-container mt-60">
                    <div className="registrar">
                    <h2 className="A-la-venta-esta-sema">Valida tu email</h2>
                    <div className="line4"></div>
                    <div className="emailvalidationmsg">
                    {
                        emailSent=== false
                        ?
                            <h4 className="subheading">
                            Hemos enviado un mensaje a tu dirección de correo electrónico para que confirmes tu email. Aún no hemos recibido la validación.
                        </h4>
                        :
                            <h4 className="subheading">
                            Email enviado correctamente a {email[0]}
                        </h4>
                        }
                    </div>
                    {
                        emailSent=== false
                        ?
                        <a className="btn2_cont validation_email_btn" onClick={() => sendValidationEmail()}>Enviar de nuevo</a>
                        :
                        <a className="btn2_cont validation_email_btn" href="/ayuda">¿Tienes dudas?</a>
                    }

                    <div className="clearfix"></div>
                    </div>

                </div>
                <div className="container line-container">
                <div className="line6"></div>
                </div>
                <SubscribeNewsLetter webTexts={webTexts}/>
        <HomeFooter />
        </>
    );
};

async function loadData(context){                   
    return {};
}

export async function getStaticProps(context) {    
    return InitializePage(context,loadData, true)
}

export default ValidationResend;
